module.exports = __webpack_public_path__ + "static/a9-16648ef28896b8ba95be67f48a25460f.jpg";